import { Floor } from '@/types/floor'
import { STATION_DETAIL } from '@/types/stations'

export const ZOOM_DEFAULT = 15
export const ZOOM_LOCATION = 12
export const ZOOM_STATION_MAX = 19
export const ZOOM_SITE_DEFAULT = 17

export interface DrawLocationsProps {
  redraw?: boolean
}

export interface LocationOverlayState {
  siteId: number
  locationId: number
  floorId: number
  floor: Floor
  overlayId: number
  overlayTypeId: number
}

export interface MarkerStationState {
  locationId: number
  floorId: number
  station: STATION_DETAIL
  note?: string
}

export enum MAP_TYPE {
  VIEW = 'VIEW',
  CUSTOM_MARKER = 'CUSTOM_MARKER',
}

export interface MarkerIcon {
  url: string
  scaledSize: google.maps.Size
  labelOrigin: google.maps.Point
}

export const MAP_CONFIG = {
  CLUSTER_SIZE: 50,
  MIN_ZOOM: 3,
  MAX_ZOOM: 18,
} as const

export const ZOOM_THRESHOLD = 20
export const DEBOUNCE_DELAY = 500

export interface MapState {
  isSiteLevel: boolean
  isLocationLevel: boolean
}

export const restrictionDefault: google.maps.MapRestriction = {
  latLngBounds: {
    west: -179.999999999,
    east: 179.999999999,
    north: 85,
    south: -85,
  },
  strictBounds: true,
}

export interface Location {
  lat: number
  lng: number
  title?: string
  description?: string
}

export enum TWO_WIRE_MODE {
  STATION_ERROR = 'STATION_ERROR',
  DECODER_LEAK_MODE = 'DECODER_LEAK_MODE',
  LOW_VOLTAGE = 'LOW_VOLTAGE',
}

export const TWO_WIRE_MODE_MAPPING = {
  [TWO_WIRE_MODE.STATION_ERROR]: {
    label: 'Station Error',
    cta: 'Run All Station Diagnostics',
  },
  [TWO_WIRE_MODE.DECODER_LEAK_MODE]: {
    label: 'Coil Side Leak',
    cta: 'Find Decoder With Leak',
  },
  [TWO_WIRE_MODE.LOW_VOLTAGE]: {
    label: 'Low Voltage',
    cta: 'Find Low Voltage Decoder',
  },
}
